if (!customElements.get('the-fold-ticker')) {
  customElements.define('the-fold-ticker', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const group = this.querySelector('.the-fold-ticker__group');
      const button = this.querySelector('button');
      if (!group) return;
      this.resizeObserver = new ResizeObserver(() => {
        this.style.setProperty('--the-fold-ticker-duration', `${group.getBoundingClientRect().width / 50}s`);
      });
      this.resizeObserver.observe(group);
      button?.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
